import { Component } from '@theme/component';
import { CartAddEvent, CartErrorEvent, ThemeEvents } from '@theme/events';

const SUCCESS_DURATION = 3500;
const ERROR_DURATION = 6000;

export class CartToastComponent extends Component {
  requiredRefs = ['toast', 'message', 'action', 'close'];

  #hideTimer = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    document.addEventListener(ThemeEvents.cartError, this.#onCartError);
    this.refs.close?.addEventListener('click', this.#hide);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    document.removeEventListener(ThemeEvents.cartError, this.#onCartError);
    this.refs.close?.removeEventListener('click', this.#hide);
    clearTimeout(this.#hideTimer);
  }

  #onCartUpdate = (event) => {
    // Only fresh adds trigger the success toast. Quantity changes and
    // removals share the same event name and must stay silent.
    if (!(event instanceof CartAddEvent)) return;
    if (event.detail?.data?.didError) return;
    this.#showSuccess();
  };

  #onCartError = (event) => {
    const message =
      event.detail?.data?.message ||
      event.detail?.data?.description ||
      '';
    this.#showError(message);
  };

  #showSuccess() {
    const toast = this.refs.toast;
    if (!toast) return;

    clearTimeout(this.#hideTimer);

    const message = this.refs.message;
    if (message) {
      message.textContent = message.dataset.defaultText || message.textContent;
    }
    this.refs.action?.removeAttribute('hidden');
    toast.classList.remove('is-error');
    toast.setAttribute('role', 'status');
    toast.removeAttribute('hidden');
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    this.#hideTimer = setTimeout(() => this.#hide(), SUCCESS_DURATION);
  }

  #showError(message) {
    const toast = this.refs.toast;
    if (!toast) return;

    clearTimeout(this.#hideTimer);

    const msgEl = this.refs.message;
    if (msgEl) {
      msgEl.textContent = message || msgEl.dataset.errorText || '';
    }
    this.refs.action?.setAttribute('hidden', '');
    toast.classList.add('is-error');
    toast.setAttribute('role', 'alert');
    toast.removeAttribute('hidden');
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    this.#hideTimer = setTimeout(() => this.#hide(), ERROR_DURATION);
  }

  #hide = () => {
    const toast = this.refs.toast;
    if (!toast) return;
    toast.classList.remove('is-visible');
    toast.setAttribute('hidden', '');
  };
}

if (!customElements.get('cart-toast-component')) {
  customElements.define('cart-toast-component', CartToastComponent);
}
